import Debug from 'debug';

//for some reason, this only works when there is some between ./ and **/
// @ts-expect-error
import {entries as stimulusControllers} from '../../../../server/**/*.stimulus.{ts,js,tsx}';

// @ts-expect-error
import {entries as webComponents} from '../../../../server/**/*.wc.{ts,js,tsx}';

import {Application} from "@hotwired/stimulus";

const debug = Debug('app:client:stimulus-autoload');

debug('autoloaded stimulus controllers', stimulusControllers);

export function loadStimulusControllers(application: Application) {
    for(const [path, module] of stimulusControllers) {

        if(!module.default) {
            console.error(`${path} does not have default export`);
            continue;
        }

        if(!module.name) {
            console.error(`${path} does not export name property`);
            continue;
        }

        debug('auto registering controller', module.name);
        application.register(module.name, module.default);
    }
}

export function loadWebComponents() {
    for(const [path, module] of webComponents) {

        if(!module.default) {
            console.error(`${path} does not have default export`);
            continue;
        }

        if(!module.name) {
            console.error(`${path} does not export name property`);
            continue;
        }

        debug('auto registering web component', module.name);
        customElements.define(module.name, module.default);
    }
}